import { header, HeaderVariant } from '@repo/themes/styled-system/recipes';
import { ComponentProps } from 'react';
import { Slot } from '@radix-ui/react-slot';

export interface HeaderProps
  extends Partial<HeaderVariant>,
    ComponentProps<'header'> {}

export interface HeaderLeftProps
  extends Partial<HeaderVariant>,
    ComponentProps<'div'> {
  asChild?: boolean;
}

export const classes = header();

const Header = ({ children, ...allProps }: HeaderProps) => {
  const [headerProps, props] = header.splitVariantProps(allProps);
  const classes = header(headerProps);
  return (
    <header className={classes.root} {...props}>
      <div className={classes.contentWrapper}>{children}</div>
    </header>
  );
};

const HeaderLeft = ({ children, asChild, ...props }: HeaderLeftProps) => {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp className={classes.elementsWrapper} {...props}>
      {children}
    </Comp>
  );
};

const HeaderRight = ({ children }: { children: React.ReactNode }) => {
  return <div className={classes.elementsWrapper}>{children}</div>;
};

const HeaderButtons = ({ children }: { children: React.ReactNode }) => {
  return <div className={classes.buttons}>{children}</div>;
};

const HeaderTitle = ({ children }: { children: React.ReactNode }) => {
  return <h1 className={classes.title}>{children}</h1>;
};

Header.displayName = 'Header.Container';
HeaderLeft.displayName = 'Header.Left';
HeaderRight.displayName = 'Header.Right';
HeaderButtons.displayName = 'Header.Buttons';
HeaderTitle.displayName = 'Header.Title';

export default {
  Container: Header,
  Left: HeaderLeft,
  Right: HeaderRight,
  Buttons: HeaderButtons,
  Title: HeaderTitle,
};
